const path = (dashboard: string, route: string) => `${dashboard}/${route}`;

export default path;
